// extracted by mini-css-extract-plugin
module.exports = {"empty":"components-RatingStars-RatingStars__empty--2KyzF","fill":"components-RatingStars-RatingStars__fill--3Er65"};